import {Routes} from '@angular/router';

export const giftCashRoutes: Routes = [
  {
    path: 'gift.cash',
    loadComponent: () => import('./gift.cash.component').then(m => m.GiftCashComponent),
    data: {title: '礼品兑付'},
    children:[
      {
        path: '',
        loadComponent: () => import('./cash.order/cash.order.component').then(m => m.CashOrderComponent),
      },
      {
        path: 'add.equity.cash',
        loadComponent: () => import('./add.equity.cash/add.equity.cash.component').then(m => m.AddEquityCashComponent),
        data: { title: '礼品权益兑付明细' },
      },
      {
        path: 'add.equity.cash/:orderId',
        loadComponent: () => import('./add.equity.cash/add.equity.cash.component').then(m => m.AddEquityCashComponent),
        data: { title: '礼品权益兑付明细' },
      },
      {
        path: 'add.lottery.cash',
        loadComponent: () => import('./add.lottery.cash/add.lottery.cash.component').then(m => m.AddLotteryCashComponent),
        data: { title: '抽奖奖品兑付明细' },
      },
      {
        path: 'add.lottery.cash/:orderId',
        loadComponent: () => import('./add.lottery.cash/add.lottery.cash.component').then(m => m.AddLotteryCashComponent),
        data: { title: '抽奖奖品兑付明细' },
      },
    ]
  },
]
